import {Component} from '@angular/core';
import {CountriesService, ICountry} from '../../services/countries.service';
import {ModalController} from '@ionic/angular';
import {filter} from 'lodash';


@Component({
  standalone: false,
  selector: 'app-code-select',
  templateUrl: './code-select.page.html',
  styleUrls: ['./code-select.page.scss'],
})
export class CodeSelectPage {
  public countries: ICountry[] = CountriesService.getCountries();
  public textFilter = '';

  constructor(
    private modalCtrl: ModalController
  ) {}


  public performSearch() {
    this.countries = filter(CountriesService.getCountries(), (c: ICountry) => {
      const str = (`${c.dialCode} ${c.code} ${c.name}`).toLocaleLowerCase();
      const search = this.textFilter.toLocaleLowerCase();

      return str.indexOf(search) > -1;
    });
  }

  public selectCountry(country: ICountry) {
    this.modalCtrl.dismiss(country);
  }

  public dismiss() {
    this.modalCtrl.dismiss();
  }
}